export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72ee028-442b-44ea-ad3d-be1abd62a5cf/artifacts/zdjtc3rc_Logo_Falo_com_o_dono-removebg-preview.png";

export const STATUS_LABELS = {
  active: { label: 'Ativo', color: 'bg-emerald-100 text-emerald-700' },
  pending: { label: 'Pendente', color: 'bg-amber-100 text-amber-700' },
  overdue: { label: 'Inadimplente', color: 'bg-red-100 text-red-700' },
  suspended: { label: 'Suspenso', color: 'bg-red-200 text-red-800' },
  pending_asaas: { label: 'Sem Cobranca', color: 'bg-red-100 text-red-700 ring-1 ring-red-300' },
  none: { label: 'Gratuito', color: 'bg-slate-100 text-slate-600' },
};

// Reexporta da fonte canonica de planos (frontend/src/constants/plans.js)
export { PLAN_LABELS, PLAN_OPTIONS_ADMIN as PLAN_OPTIONS } from '@/constants/plans';
